import script from "./AsideModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsideModal.vue?vue&type=script&setup=true&lang=ts"

import "./AsideModal.vue?vue&type=style&index=0&id=78b71a7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b71a7c"]])

export default __exports__